import BaseApi from '@/api/controller/base';

const DEPOSIT_API_URL = 'deposit/';

class DepositApi extends BaseApi {
  constructor() {
    super(DEPOSIT_API_URL);
  }

  create(depositTO) {
    return this.api.post('', depositTO);
  }

  update(deposit) {
    const depositId = deposit.id;
    if (depositId) {
      return this.api.post(`${depositId}`, deposit);
    }
    return Promise.error('Please specify an id for the deposit.');
  }
}

const apiInstance = new DepositApi();
export { DepositApi, apiInstance };
export default apiInstance;
